
const kw=new URLSearchParams(location.search).get('kw');
if(kw){const clean=kw.replace(/[^a-zA-Z0-9À-ɏ ,'-]/g,'').trim().slice(0,60);
  if(clean.length>2)document.querySelectorAll('[data-dtr]').forEach(el=>el.textContent=clean.toUpperCase());}
document.documentElement.classList.add('js-reveal');
const io=new IntersectionObserver(e=>e.forEach(x=>x.isIntersecting&&x.target.classList.add('in')),
  {threshold:.15});
document.querySelectorAll('.card,.step').forEach((el,i)=>{el.style.transitionDelay=(i%3*90)+'ms';io.observe(el)});
const f=document.querySelector('form[data-lead]');
if(f){f.addEventListener('submit',async ev=>{
  ev.preventDefault();
  const b=f.querySelector('button');b.disabled=true;b.textContent=f.dataset.sending;
  const d=Object.fromEntries(new FormData(f).entries());
  d.source=location.pathname;
  try{const r=await fetch('https://cosmos-fl.adsfly-aios.workers.dev/api/lead',{method:'POST',headers:{'content-type':'application/json'},
    body:JSON.stringify(d)});
    if(!r.ok)throw 0;
    const sel=f.querySelector('[data-value]');
    const val=sel?parseInt(sel.value,10):1;
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push({event:'generate_lead',lead_value:val,lead_type:val>=40?'development':
      (val>=10?'multi_unit':'single'),page:location.pathname});
    var CONV={1:'AW-1045938534/rVLWCIieuOkcEOaC3_ID',10:'AW-1045938534/R4XkCIueuOkcEOaC3_ID',
              40:'AW-1045938534/klKLCI6euOkcEOaC3_ID'};
    if(typeof gtag==='function')gtag('event','conversion',
      {send_to:CONV[val]||CONV[1],value:val,currency:'USD'});
    f.style.display='none';document.querySelector('.ok').classList.add('show');
    window.scrollTo({top:document.querySelector('.ok').offsetTop-120,behavior:'smooth'});
  }catch(e){
    setTimeout(function(){b.disabled=false;b.textContent=f.dataset.retry;},4000);
  }
});}
